// test1292
(1292 && 0);
